import React from "react";

const Button = ({ type, onClick, children, className, disabled, title, ...rest }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`px-4 py-2 rounded ${className} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={disabled}
      title={title}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
